// import logo from './logo.svg';
import { useEffect } from 'react';
import './App.css';
import AllRoute from './allroutes/AllRoute';

function App() {

  useEffect(()=>{
    console.log("chat url 12333" , process.env);
    
  },[])
  return (
    <div className="App">
    <AllRoute/>
    </div>
  );
}

export default App;


